/**
 * Tuijn Code Export Version Download Formatter.
 */
window.tuijncodeExportVersionDownloadFormatter = function(value, row) {
    let html = '';
    html += '<a href="/tuijncode/exports/versions/download/'+row.id+'">';
    html += '<i class="fa fa-download"></i>';
    html += '</a>';
    return html;
}
